import getParent from '../selectors';

export const getCutoffs = state => getParent(state).cutoffs;

export const doCutoffsExist = state => !!getCutoffs(state);
